
import React from "react";
import { Star, Gift, Crown, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

const EarlyAccessBenefits: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gradient-to-r from-propmatch-blue/10 to-propmatch-blue-light/10 border border-propmatch-blue/20 rounded-xl p-3 sm:p-4 space-y-3">
      <h4 className="font-bold text-sm sm:text-base text-white flex items-center gap-2">
        <Star className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" />
        {t("earlyAccess.benefits.title")}
      </h4>
      
      <div className="grid grid-cols-1 gap-2">
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-green-400 to-emerald-500 flex items-center justify-center flex-shrink-0">
            <Gift className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
          </div>
          <div>
            <p className="font-semibold text-white text-xs sm:text-sm">{t("earlyAccess.benefits.freeToken.title")}</p>
            <p className="text-xs text-propmatch-text-gray">{t("earlyAccess.benefits.freeToken.description")}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-propmatch-blue to-propmatch-blue-light flex items-center justify-center flex-shrink-0">
            <Crown className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
          </div>
          <div>
            <p className="font-semibold text-white text-xs sm:text-sm">{t("earlyAccess.benefits.priorityAccess.title")}</p>
            <p className="text-xs text-propmatch-text-gray">{t("earlyAccess.benefits.priorityAccess.description")}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-purple-400 to-pink-500 flex items-center justify-center flex-shrink-0">
            <Zap className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
          </div>
          <div>
            <p className="font-semibold text-white text-xs sm:text-sm">{t("earlyAccess.benefits.reducedCommissions.title")}</p>
            <p className="text-xs text-propmatch-text-gray">{t("earlyAccess.benefits.reducedCommissions.description")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarlyAccessBenefits;
